import {useThemes} from "../../style/themes.hook";
import {graphql, useStaticQuery} from "gatsby";
import {ThemeProvider} from "styled-components";
import {Heading4, MaxWidthContainer, Paragraph} from "../../style/itf-styled-components";
import {FestivalCategory} from "../festival-category";
import Img from "gatsby-image/withIEPolyfill";
import React from "react";
import {Section} from "./section";
import {useVmembers} from "../../data/hooks/members";
import {MembersAvatarList} from "../members-avatar-list";

export const VimagineSection = () => {
  const themes = useThemes();
  const images = useStaticQuery(graphql`
        query vImagine {
          vimagine: file(relativePath: { eq: "straight-from-the-camera-video.png" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }`
  );

  return (
    <ThemeProvider theme={themes.light}>
      <MaxWidthContainer
        as={Section}
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 100px;

          @media (max-width: ${props => props.theme.mobileWidth}) {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        `}
      >
        <div>
          <span css={`font-size: 2em;`}>
            <FestivalCategory category={"v"}/>
          </span>
          <Heading4>Videografie</Heading4>
          <Paragraph>O doză proaspătă de inspirație, la pachet cu tehnici și viziune videografică, vă așteaptă în cadrul secțiunii VImagine a ITF. Veți putea învăța toate skillurile de care aveți nevoie în 2021 și după, de la specialiști renumiți în domeniu, în cadrul workshop-urilor și masterclass-urilor de videografie pe care vi le-am pregătit.</Paragraph>
        </div>
        <div
          css={`
            display: flex;
            justify-content: flex-end;

            @media (max-width: ${props => props.theme.mobileWidth}) {
              justify-content: center;
              margin-top: 50px;
            }
          `}
        >
          <Img
            css={`
              width: 100%;
              max-width: 424px;
            `}
            fluid={images.vimagine.childImageSharp.fluid}
            objectPosition="50% top"
          />
        </div>
      </MaxWidthContainer>
      <MaxWidthContainer
        as={Section}
        css={`
          padding-bottom: 100px;
          padding-top: 0;
        `}
      >
        <MembersAvatarList speakers={useVmembers()}/>
      </MaxWidthContainer>
    </ThemeProvider>
  );
}